<template>
  <div class="offer-type-card" v-if="ofertaShow">
    <div class="offer-type-card__thumbnail">
      <div
        class="offer-type-card__price-label"
        :class="getNazwa()"
        v-show="cenaShow"
      >
        <span class="d-block">cena od</span>
        <span class="d-block font-m font-22">{{ getCenaOd() }} zł</span>
      </div>
      <img :src="getImgUrl()" alt="" />
    </div>
    <div class="offer-type-card__content">
      <div class="offer-type-card__desc">
        <h3 class="font-20">{{ getTitle() }}</h3>
        <p v-html="getOpis()"></p>
      </div>
      <div class="mb-8 mt-auto text-center">
        <a :href="getZestUrl()" class="btn btn-md btn-d-blue">Szczegóły</a>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONFIG from "../config.js";

export default {
  props: {
    oferta: Object,
    cena: Object
  },
  data: () => ({
    cenaShow: true,
    ofertaShow: true
  }),
  methods: {
    getCenaOd() {
      if (this.cena && typeof this.cena.cenamin === "string") {
        this.ofertaShow = true;
        return this.cena.cenamin;
      } else {
        this.ofertaShow = false;
        return "";
      }
    },
    getImgUrl() {
      return (
        "https://www." + CONFIG.serwis + "/photo/grupa/" + this.oferta.zdjecie
      );
    },
    getTitle() {
      return this.oferta.child.snazwa;
    },
    getOpis() {
      return this.oferta.child.tekstzb;
    },
    getNazwa() {
      return this.oferta.child.nazwa;
    },
    getZestUrl() {
      //let prefixString = this.oferta.child.prefix.replace(/=/g, "-");
      if (this.oferta.url.indexOf("autokar") !== -1) {
        return this.oferta.url;
      } else {
        return this.oferta.url + "?adt=2&pobyt=7";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.offer-type-card {
  background-color: #fff;
  // border: 1px solid $border-color;
  // border-radius: 3px;
  display: flex;
  flex-direction: column;
  // padding: 12px;
  width: 100%;
  height: 100%;

  &__thumbnail {
    border-radius: 3px 3px 0 0;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    // margin-bottom: 12px;
    overflow: hidden;
    position: relative;
    height: 50vw;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      align-items: flex-start;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
    }

    @media (min-width: $screen-xs) {
      height: 30vw;
    }

    @media (min-width: $screen-md) {
      height: 198px;
    }
  }

  &__price-label {
    background-color: rgba(darkmagenta, 0.82);
    border-bottom-right-radius: 20px;
    color: #fff;
    padding: 5px 16px 5px 12px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;

    &.romantycznewczasy,
    &.allte,
    &.sport {
      background-color: rgba(#f42020, 0.82);
    }

    &.alllz,
    &.dlarodzinzdziecmi {
      background-color: rgba(#38ad1a, 0.82);
    }

    &.apartamenty,
    &.bliskolotniska {
      background-color: rgba(#a034e2, 0.82);
    }

    &.lato2021,
    &.nurkowanie,
    &.zeglarstwo {
      background-color: rgba(#1e5fae, 0.82);
    }

    &.zycienocne,
    &.basenkryty,
    &.all {
      background-color: rgba(#ce1bb3, 0.82);
    }

    &.niepelnosprawni,
    &.allgc,
    &.luksusowewczasy {
      background-color: rgba(#1a830f, 0.82);
    }

    &.sportywodne,
    &.apartamenty,
    &.bliskoplazy {
      background-color: rgba(#08a8aa, 0.82);
    }

    &.bliskocentrum,
    &.allfu,
    &.wakacjewspa {
      background-color: rgba(#cf5013, 0.82);
    }
  }

  &__content {
    border: 1px solid $border-color;
    border-radius: 0 0 3px 3px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 12px;
  }
}
</style>
